import api from 'lib/Api'
import * as actions from './actions'
import { addNotification } from 'store/notifications'
import { getReadableErrorMessage } from 'utils/errorUtils'
import { push } from 'connected-react-router'

export const fetchAndHandlePreviewDeleteUser = deleteUserParameters => {
  return async function (dispatch) {
    dispatch(actions.fetchingPreviewDeleteUser())
    const { userEmail } = deleteUserParameters

    if (userEmail) {
      try {
        const response = await api.get(
          `/licenseuserrole/DeleteUserPreview?email=${encodeURIComponent(
            userEmail,
          )}`,
        )
        const data = response.data !== '' ? response.data : null
        dispatch(actions.fetchingPreviewDeleteUserSuccess(data))
      } catch (error) {
        const errorMessage = getReadableErrorMessage(
          error,
          'An error occurred while loading the delete user preview.',
        )
        dispatch(
          addNotification({
            color: 'danger',
            text: errorMessage,
          }),
        )
        dispatch(actions.fetchingPreviewDeleteUserError(errorMessage))
      }
    } else {
      dispatch(
        actions.fetchingPreviewDeleteUserError('missing userEmail to delete'),
      )
    }
  }
}

export const HandleDeleteUser = deleteUserParameters => {
  return async function (dispatch) {
    dispatch(actions.deletingUser())
    const { userEmail } = deleteUserParameters

    if (userEmail) {
      try {
        const response = await api.delete(
          `/profile/deleteUser/${encodeURIComponent(userEmail)}`,
        )

        dispatch(
          addNotification({
            color: 'success',
            text: `You have sucessfully deleted ${userEmail} from the system`,
          }),
        )
        const data = response.data !== '' ? response.data : null
        dispatch(actions.deletingUserSuccess(data))
        dispatch(push('/css-admin/users'))
      } catch (error) {
        const fallback = `${userEmail} was not deleted from the system`
        const errorMessage = getReadableErrorMessage(error, fallback)
        const notificationText =
          errorMessage === fallback
            ? errorMessage
            : `${errorMessage} ${userEmail} was not deleted from the system`
        dispatch(
          addNotification({
            color: 'danger',
            text: notificationText,
          }),
        )
        dispatch(actions.deletingUserError(errorMessage))
      }
    } else {
    }
  }
}
